import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";

import FacetGroup from "./FacetGroup.jsx";
import Icon from "../../components/Icon/Icon.jsx";

import {
  closeFilters,
  setFiltersOpenDirection,
  manageContainerWhitespace,
  addPriorityContainerClass,
} from "../filterSlider";

export default class FacetList extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setFiltersOpenDirection();
    manageContainerWhitespace();
    addPriorityContainerClass();
  }

  clearAll() {
    this.props.handleClearAll();
  }

  hideFilters() {
    closeFilters(); // DOM ops
    this.props.hideMobileFacets(); // action creator
  }

  renderHideFilters() {
    return (
      <div className="search-facets__filter-close">
        <button
          type="button"
          className="btn search-facets__close-button"
          onClick={() => this.hideFilters()}
        >
          <svg className="icon">
            <use xlinkHref="/assets/VelirSite-build/img/svg-sprite.svg#close"></use>
          </svg>
          <span>Close</span>
        </button>
      </div>
    );
  }

  renderFacetGroups() {
    return this.props.facets.map((group, i) => {
      if (group.values.length === 0 && group.childGroups.length === 0) {
        return null;
      }
      const numOpenGroups = this.props.numOpenGroups;
      const isOpen =
        typeof numOpenGroups !== "undefined" &&
        numOpenGroups !== null &&
        i < numOpenGroups;
      return (
        <FacetGroup
          key={group.id}
          handleFacetChange={this.props.handleFacetChange}
          handleClearGroup={this.props.handleClearGroup}
          isOpen={isOpen}
          group={group}
        />
      );
    });
  }

  renderClearAll() {
    return (
      <div className="search-facets__clear-all">
        <button type="button" onClick={() => this.clearAll()}>
          <span>Clear all filter selections</span>
          <Icon iconName="close" />
        </button>
      </div>
    );
  }

  render() {
    const facetGroups = this.renderFacetGroups();

    return (
      <div className="search__facets-container">
        <div className="search-facets">
          <div className="search-facets__title">{this.props.title}</div>
          {facetGroups}
          {this.renderClearAll()}
        </div>
        {this.renderHideFilters()}
      </div>
    );
  }
}

const { string, arrayOf, bool, shape, number, oneOfType, func } = PropTypes;
FacetList.propTypes = {
  title: string,
  mobileFiltersShown: bool,
  hideMobileFacets: func,
  facets: arrayOf(shape({ id: oneOfType([number, string]) })),
  numOpenGroups: number,
  handleFacetChange: func.isRequired,
  handleClearGroup: func.isRequired,
  handleClearAll: func.isRequired,
};

FacetList.defaultProps = {
  facets: [],
  numOpenGroups: null,
};
